export default __webpack_public_path__ + "static/media/login_hero.7fd0e21e.png";